import { Input, Popconfirm, Table, Spin, message } from "antd";
import React from "react";
import api from "../../../../../utils/api";
import qs from "../../../../../utils/qs";
import './index.sass'

export default class GroupGoods extends React.Component {
    constructor(props) {
        super(props)

        //console.log(props, '----------')

        this.state = {
            dataSource: [],
            change_timer: null,
            gb_batch_id: props.gb_batch_id
        }
    }

    componentDidUpdate() {

    }

    componentWillReceiveProps(){
        // console.log(this.props,'D4C?ED*PH-HNBSEGPXU5C9W3A@D@XS')
        this.setState({
            gb_batch_id: this.props.gb_batch_id
        })
    }

    change_stock = (e, v, ctx) => {
        v['stock'] = e.target.value;
        let { dataSource, change_timer } = this.state;

        this.setState({
            dataSource
        })

        if (change_timer) return message.error('3s后可重新修改');

        this.gb_update(ctx, v)

        change_timer = setTimeout(() => {//防抖

            clearTimeout(change_timer)

            this.setState({
                change_timer: null
            })

        }, 3000)

        this.setState({
            change_timer
        })


        //console.log(e, 'change_stock', dataSource, dataSource, ctx, '---------------------', this.props)

    }

    gb_update = async (ctx, v) => {
        let id = qs.hrefParam('id');
        let { referable } = this.props;
        referable = referable == true ? 'true' : 'false';
        let { gb_batch_id } = this.state;
        let param = {
            referable,
            gb_id: Number(id),
            gb_batch_id: Number(gb_batch_id),
            products: {
                id: ctx.id,
                entity_id: v.id,
                stock: v.stock
            }

        }
        // let res = await api('update-gb-products-stock', param)
        let res = await api('update-gb-products-stock', param)

        if (res.code === 200) {
            message.success(res.message)
        } else {
            message.error(res.message)
        }

        //console.log(res, 'update-gb-products-stockupdate-gb-products-stock')
    }

    render() {
        let { dataSource } = this.state;
        let { shop_goods } = this.props;

        //console.log(this.props)

        const columns = [
            {
                title: '商品名称',
                width: 50,
                render: (ctx) => {
                    return (
                        <p className='oneLine width50'>{ctx.name}</p>
                    )
                }
            },
            {
                title: '价格',
                width: 50,
                render: (ctx) => {
                    return (

                        shop_goods ? (
                            <table border="0" className='goodsTable' >
                                <tbody>
                                    <tr>
                                        <th style={{ width: 50 }}></th>
                                        <th style={{ width: 50 }}></th>
                                        <th style={{ width: 50 }}></th>
                                        <th style={{ width: 50 }}></th>
                                    </tr>
                                    {
                                        ctx['entities'].map((v, i) => {

                                            return (
                                                <tr className={'group_list_table_tr'}>
                                                    <td style={{ width: 50, padding: '0 10px' }}>
                                                        ￥{v['price']}/

                                                        {/* ({v['specs'] && v['specs'][0] ? v['specs'][0]['value_name'] : ''}) */}

                                                        {
                                                            v['specs'] && v['specs'][0] ? (
                                                                (v['specs'][0]['value_name'])
                                                            ) : null
                                                        }

                                                    </td>
                                                    <td style={{ width: 50, padding: '0 10px' }}>
                                                        <div className='flex'>
                                                            <Input style={{ flex: '0 0 50px' }} size='small' value={v['stock']} onChange={(e) => { this.change_stock(e, v, ctx) }} />
                                                            {/* <Popconfirm

                                                                title='修改该批次商品库存？'
                                                                onConfirm={() => { console.log(v) }}
                                                                okText='确定'
                                                                cancelText='取消'

                                                            >
                                                                <p className='mgl5'>修改</p>
                                                            </Popconfirm> */}
                                                        </div>


                                                    </td>
                                                    <td style={{ width: 50, padding: '0 10px' }}>{v['commission_rate']}</td>
                                                    <td style={{ width: 50, padding: '0 10px' }}>{ }</td>
                                                </tr>
                                            )

                                        })
                                    }
                                </tbody>
                            </table >
                        ) : (<Spin></Spin>)


                    )

                }
            },
            {
                title: '库存',
                width: 50,
                render: () => { }
            },
            {
                title: '返佣比例',
                width: 50,
                render: () => { }
            },
            {
                title: '已售',
                width: 50,
                render: () => { }
            },
        ];
        return (
            <div className='groupGoods mgl20'>
                <p className='title'>当前勾选中到货时间的商品列表</p>

                <div className='pd20'>
                    <Table dataSource={shop_goods} columns={columns} scroll={{ x: true }} pagination={false} />
                </div>
            </div>
        )
    }

}